import * as React from 'react';
import { StyledContextualMenuItem, ContextualMenuItemIcon } from './styles';
import Utils from '../../../utils';
import { Translate } from 'react-redux-i18n';

interface ContextualMenuItemProps {
	label: string;
	iconName: string;
	color: string;
	size: number;
	onClick: () => void;
	className: string;
	hoverLabel?: string;
	hoverIconName?: string;
}

class ContextualMenuItem extends React.Component<ContextualMenuItemProps, never> {
	constructor(props: ContextualMenuItemProps) {
		super(props);
	}

	render() {
		const { label, color, iconName, size, onClick, hoverLabel, hoverIconName, className } = this.props;

		return (
			<StyledContextualMenuItem
				className={className}
				color={color}
				onClick={onClick}
				hasHoverIcon={!!hoverIconName}
				hasHoverLabel={!!hoverLabel}
			>
				<Translate className="menuLabel" value={label} />
				{hoverLabel &&
					<Translate className="menuLabelHover" value={hoverLabel} />
				}
				<ContextualMenuItemIcon
					className="menuIcon"
					size={size}
				>
					{Utils.getSvgIcon(iconName)}
				</ContextualMenuItemIcon >

				{hoverIconName &&
					<ContextualMenuItemIcon
						className="menuIconHover"
						size={size}
					>
						{Utils.getSvgIcon(hoverIconName)}
					</ContextualMenuItemIcon >
				}

			</StyledContextualMenuItem>
		);
	}
}

export default ContextualMenuItem;
export {
	ContextualMenuItemProps
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/Item/index.tsx